import React from "react";
const Sitemap = () =>
  window.open(
    "https://magento.fairfieldchair.com/media/sitemap/sitemap.xml",
    "_self"
  );

export default Sitemap;
